import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";

export function CallbackModal({ open, onOpenChange, form, onFormChange, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-[#6A7359]">Request a Callback</DialogTitle>
          <DialogDescription>Leave your number and we will call you.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 mt-3">
          <Input 
            placeholder="Name *" 
            value={form.name} 
            onChange={(e) => onFormChange("name", e.target.value)} 
            data-testid="callback-name" 
          />
          <Input 
            placeholder="Phone Number *" 
            value={form.phone} 
            onChange={(e) => onFormChange("phone", e.target.value)} 
            data-testid="callback-phone" 
          />
          <Input 
            placeholder="Preferred time (e.g., Morning, 2pm)" 
            value={form.time} 
            onChange={(e) => onFormChange("time", e.target.value)} 
            data-testid="callback-time" 
          />
          <Input 
            placeholder="What can we help with?" 
            value={form.notes} 
            onChange={(e) => onFormChange("notes", e.target.value)} 
            data-testid="callback-notes" 
          />
          <div className="flex gap-2 pt-2">
            <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1">
              Cancel
            </Button>
            <Button 
              onClick={onSubmit} 
              className="flex-1 bg-[#6A7359] hover:bg-[#565E48]" 
              data-testid="submit-callback-btn"
            >
              Request Call
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
